import React, { useEffect, useState } from "react";
// import { AccessTypesPopoverHost, AccessTypesPopover } from "./components/AccessTypesPopover";
import { useDispatch } from "react-redux";
import Col from 'react-bootstrap/Col';
import { Button, Form } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import { updateTitle } from "../../redux/updatePageHeadeSlice";
import { ADMIN_DASHBOARD_HEADER } from "../../constants/headerTitles";
import { Popover, Select } from 'antd';
// import { useQuery } from "react-query";
import getDatabaseConnection from "../../api/getDatabaseConnection";
import { useFormik } from 'formik';
import connectDatabase from "../../api/connectDatabasr";
import Loader from '../../pages/utilities/loader';
import { showToastAction } from "../../redux/toastSlice";

const ConnectionPage = () => {
    // const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    // const [isPopoverOpenHost, setIsPopoverOpenHost] = useState(false);
    const [loading, setLoading] = useState(false)
    const [modify, setModify] = useState(false)
    // const [data, setData] = useState({})
    const [modifyConnection, setModifyConnection] = useState({ disabled: true, button: true, edit: false })
    // 
    const dispatch = useDispatch()
    // const { isLoading, data } = useQuery('getDatabaseConnection', () => getDatabaseConnection());

    // if (isLoading) return <><Loader /></>

    useEffect(() => {
        fetchData()
    }, [])

    useEffect(() => {
        dispatch(updateTitle(ADMIN_DASHBOARD_HEADER))
    }, [])

    // useEffect(() => {

    // }, [data])

    async function fetchData() {
        const resData = await getDatabaseConnection()
        // setData(resData)
        console.log('resData getDatabaseConnection', resData)
        if (resData) {
            setModifyConnection({ disabled: true, button: true, edit: false })
            formik.setValues({
                db_type: resData?.db_type,
                db_ip_address: resData?.db_ip_address,
                db_port: resData?.db_port,
                db_username: resData?.db_username,
                db_pwd: resData?.db_pwd
            })


            if (resData?.db_ip_address === '' && resData?.db_port === '' && resData?.db_pwd === '' && resData?.db_username === '') {
                setModifyConnection({ disabled: false, button: false, edit: false })
            }
        }
    }

    // useEffect(() => {
    //     // console.log('modify', modify)
    //     if (data) {
    //         formik.setValues({
    //             db_type: data?.db_type,
    //             db_ip_address: data?.db_ip_address,
    //             db_port: data?.db_port,
    //             db_username: data?.db_username,
    //             db_pwd: data?.db_pwd
    //         })
    //     }
    //     console.log(
    //         "data && data?.db_port !== '' && data?.db_pwd !== '' && data?.db_username !== ''",
    //         data && data?.db_port !== '' && data?.db_pwd !== '' && data?.db_username !== ''
    //     );
    //     if (data && data?.db_port !== '' && data?.db_pwd !== '' && data?.db_username !== '') {
    //         setModifyConnection({ disabled: true, button: true })
    //     }
    // }, [data])

    const formik = useFormik({
        initialValues: {
            db_type: 'mongodb',
            db_ip_address: '',
            db_port: '',
            db_username: '',
            db_pwd: ''
        },
        onSubmit: values => {
            if (modifyConnection.disabled) {
                setModifyConnection({ ...modifyConnection, disabled: false, edit: true })
            } else connectDatabaseHandler(values)
        },
    });
    console.log('formik.value', formik.values);
    const connectDatabaseHandler = async (values) => {
        try {
            setLoading(true)
            const res = await connectDatabase(values)
            dispatch(showToastAction({ message: res?.data ?? "Success", showToast: true, severity: "success" }))
            await fetchData()
            // const getData = await getDatabaseConnection()
            // setData(getData)
            setLoading(false)
            // alert(res.data)
        } catch (error) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }

    return (
        <>
            {/* <AccessTypesPopover popoverOpen={isPopoverOpen} toggle={toggle} />
            <AccessTypesPopoverHost popoverOpen={isPopoverOpenHost} toggle={toggleHost} /> */}

            <div>
                <div className="wrap-text">
                    <h3>Database</h3>
                    <Popover placement="right" content={'Fill the database information. All project details and extracted data of the documents will be stored there.'}>
                        <i className="ti-help border rounded-full w-5 h-5 grid place-items-center cursor-pointer" />
                    </Popover>
                </div>
                <Form>
                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalDataType">
                        <Form.Label column sm={2}>
                            Data Type
                        </Form.Label>
                        <Col md={2}>
                            <Select
                                name='db_type'
                                disabled={modifyConnection.disabled}
                                defaultValue={formik.values.db_type}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                style={{ width: '100%' }}
                                options={[
                                    {
                                        value: 'mongodb',
                                        label: 'Mongodb',
                                    },
                                    {
                                        value: 'oracle',
                                        label: 'Oracle',
                                    },
                                    {
                                        value: 'teradata',
                                        label: 'Teradata',
                                    },
                                ]}
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalHost">
                        <Form.Label column sm={2} className='d-flex align-items-center gap-2'>
                            Host
                            <Popover placement="right" content={'Add the ip address or url of the database. If you are using a url add the full url containing username and password.'}>
                                <i className="ti-help border rounded-full w-5 h-5 grid place-items-center cursor-pointer" style={{ fontSize: 10 }} />
                            </Popover>
                        </Form.Label>
                        <Col md={2}>
                            <Form.Control
                                disabled={modifyConnection.disabled}
                                type="password"
                                size="sm"
                                name='db_ip_address'
                                defaultValue={formik.values.db_ip_address}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalPort">
                        <Form.Label column sm={2}>
                            Port
                        </Form.Label>
                        <Col md={2}>
                            <Form.Control
                                disabled={modifyConnection.disabled}
                                name='db_port'
                                type="text"
                                size="sm"
                                defaultValue={formik.values.db_port}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalUser">
                        <Form.Label column sm={2}>
                            User
                        </Form.Label>
                        <Col md={2}>
                            <Form.Control
                                disabled={modifyConnection.disabled}
                                name='db_username'
                                type="text"
                                size="sm"
                                defaultValue={formik.values.db_username}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalPassword">
                        <Form.Label column sm={2}>
                            Password
                        </Form.Label>
                        <Col md={2}>
                            <Form.Control
                                disabled={modifyConnection.disabled}
                                type="password"
                                name='db_pwd'
                                size="sm"
                                defaultValue={formik.values.db_pwd}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        {/* <Col md={{ span: 10, offset: 2 }}> */}
                        <Col md={1} />
                        <Col md={3} className='connect-btn'>
                            <Button onClick={() => formik.handleSubmit()}>{modifyConnection.edit ? 'Create' : modifyConnection.button ? 'Modify Connection' : 'Create'}</Button>
                        </Col>
                    </Form.Group>
                </Form>
                <br />

                <div className="wrap-text">
                    <h3>Server</h3>
                    <Popover placement="right" content={'Fill the server information. Archived files will be sotred on this server. If not filled, the files will be stored on the back-end server.'}>
                        <i id="AccessTypesPopover" className="ti-help border rounded-full w-5 h-5 grid place-items-center cursor-pointer" />
                    </Popover>
                </div>
                <Form>
                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalHost">
                        <Form.Label column sm={2}>
                            Host
                        </Form.Label>
                        <Col md={2}>
                            <Form.Control type="text" size="sm" placeholder="" />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalPort">
                        <Form.Label column sm={2}>
                            Port
                        </Form.Label>
                        <Col md={2}>
                            <Form.Control type="text" size="sm" placeholder="" />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalUser">
                        <Form.Label column sm={2}>
                            User
                        </Form.Label>
                        <Col md={2}>
                            <Form.Control type="text" size="sm" placeholder="" />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalPassword">
                        <Form.Label column sm={2}>
                            Password
                        </Form.Label>
                        <Col md={2}>
                            <Form.Control type="password" size="sm" placeholder="" />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalPort">
                        <Form.Label column sm={2}>
                            Path
                        </Form.Label>
                        <Col md={2}>
                            <Form.Control type="text" size="sm" placeholder="" />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        {/* <Col sm={{ span: 10, offset: 2 }}> */}
                        <Col md={2} />
                        <Col md={2} className='connect-btn'>
                            <Button>Create</Button>
                        </Col>
                    </Form.Group>
                </Form>
            </div>
        </>
    );
};

export default ConnectionPage;
